<mat-card class="cardWithShadow">
  <div class="button_minutes">
    <button mat-stroked-button color="primary" class="w-50" (click)="openRegisterMinutes()">
      Nueva Minuta
    </button>
  </div>
  <mat-card-content>

    <div style="text-align: center;" *ngIf="dataSource.data.length == 0">
      <h3>Sin Minutas</h3>
    </div>

    <div class="table-responsive m-t-12" [ngClass]="{ 'oculto': dataSource.data.length == 0 }">
      <table mat-table [dataSource]="dataSource" class="w-100" matSort matSortDirection="desc"
        matSortActive="minuteRequestId">

        <ng-container matColumnDef="minuteRequestId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Codigo Minuta
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1" (click)="redirectMinute(element.minuteRequestId)"
            style="color: blue; cursor: pointer; font-weight: bold;">
            <h6>{{ element.minuteRequestId }}</h6>
          </td>
        </ng-container>
        
        <ng-container matColumnDef="minuteState">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Estado
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h4 [ngStyle]="getStateColor(element.minuteState)">
              {{ element.minuteState }}
            </h4>
          </td>
        </ng-container>

        <ng-container matColumnDef="lineApproved">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Línea Factoring
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.lineApproved | currency:'CLP':'symbol' }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="lineApprovedWarranties">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Línea Garantías
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.lineApprovedWarranties | currency:'CLP':'symbol' }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Fecha Creacion
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.createdAt | date : "dd/MM/yyyy" }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="dueDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
            Fecha Expiracion
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.dueDate | date : "dd/MM/yyyy" }}</h6>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" >
        </tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>